module.exports = __webpack_public_path__ + "static/media/YGY_Products.32db5adc.png";